import React, { useEffect } from "react";
import { BooleanInput, useListFilterContext } from "react-admin";

type Props = {
  source: string;
  label?: string;
};

const BooleanExistsFilter: React.FC<Props> = ({ source }) => {
  const { filterValues, setFilters } = useListFilterContext();
  // Determine checked state based on filter value
  const value =
    filterValues &&
    filterValues[source] &&
    (filterValues[source].$ne === "null"
      ? true
      : filterValues[source].$eq === "null"
      ? false
      : undefined);

  // Force setFilters to false if value is undefined
  useEffect(() => {
    if (value === undefined) {
      setFilters({
        ...filterValues,
        [source]: { $eq: "null" }, // Default to unchecked
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, filterValues, setFilters, source]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilters({
      ...filterValues,
      [source]: event.target.checked ? { $ne: "null" } : { $eq: "null" },
    });
  };

  return (
    <BooleanInput source={source} checked={!!value} onChange={handleChange} />
  );
};

export default BooleanExistsFilter;
